<template>
  <div>
    <!-- <label for="pacViewPlace">COGNEETIV MAP</label> -->
    <label for="pacViewPlace" style="color: aliceblue; font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;">COGNEETIV MAP</label>
 <input
   type="text"
   id="place_changed"
   name="pacViewPlace"
   placeholder="Enter a location..."
   style="width: 400px; margin-bottom: 10px; top: 100px;"
 />
 <button @click="place_changed" style="background-color: #0a0a0a; color: aliceblue; font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;">Submit</button>
    <div id="cesiumContainer" class="fullSize"></div>
    <div id="loadingOverlay"><h1>Loading...</h1></div>
    <div id="toolbar"></div>
    
  </div>
</template>

<script>
/* global Cesium, google */ // This tells ESLint that Cesium and google are global variables

export default {
  name: "CesiumMap",
  data() {
    return {
      viewer: null
    };
  },
  mounted() {
    this.initCesium();
    this.loadGoogleMapsApi();
    const viewer = new Cesium.Viewer("cesiumContainer");  
    viewer.terrainProvider = Cesium.createWorldTerrain();
  },
  methods: {
    initCesium() {
      Cesium.RequestScheduler.requestsByServer["tile.googleapis.com:443"] = 20;

      this.viewer = new Cesium.Viewer("cesiumContainer", {
        imageryProvider: false,
        baseLayerPicker: false,
        requestRenderMode: true,
        geocoder: false,
        globe: false
      });

      this.viewer.scene.primitives.add(
        new Cesium.Cesium3DTileset({
          url: "https://tile.googleapis.com/v1/3dtiles/root.json?key=AIzaSyB3Vn2Bmfyw9gLbnRnEgwC92LBZdaWXzC8",
          showCreditsOnScreen: true
        })
      );

      this.flyToUserLocation();
    },
    loadGoogleMapsApi() {
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyB3Vn2Bmfyw9gLbnRnEgwC92LBZdaWXzC8&libraries=places&callback=initAutocomplete";
      script.async = true;
      document.body.appendChild(script);
      window.initAutocomplete = this.initAutocomplete;
    },
    flyToUserLocation() {
      navigator.geolocation.getCurrentPosition(position => {
        this.viewer.camera.flyTo({  // changed `viewer` to `this.viewer`
            destination: Cesium.Cartesian3.fromDegrees(
                position.coords.longitude,
                position.coords.latitude,
                300.0
            ),
            orientation: {
                pitch: Cesium.Math.toRadians(-25.0),
            },
            complete: function() {
                setTimeout(() => {
                    this.viewer.camera.flyHome();  // changed `viewer` to `this.viewer`
                    alert('Enter Location you want to see');
                }, 15000);
            }.bind(this) // To retain the value of this inside the function
        });
      });
    },
    
    zoomToViewport(viewport) {
      let polylineEntity = this.viewer.entities.add({
        polyline: {
            positions: Cesium.Cartesian3.fromDegreesArray([
                viewport.getNorthEast().lng(), viewport.getNorthEast().lat(),
                viewport.getSouthWest().lng(), viewport.getNorthEast().lat(),
                viewport.getSouthWest().lng(), viewport.getSouthWest().lat(),
                viewport.getNorthEast().lng(), viewport.getSouthWest().lat(),
                viewport.getNorthEast().lng(), viewport.getNorthEast().lat(),
            ]),
            width: 5,
            clampToGround: true,
            material: Cesium.Color.BLUE,
        },
      });

      this.viewer.flyTo(polylineEntity, {
        offset: {
            heading: 0,
            pitch: Cesium.Math.toRadians(-25.0),
            range: 300.0  // This might need to be adjusted depending on your needs.
        }
      });
    },
    initAutocomplete() {
      const autocomplete = new google.maps.places.Autocomplete(
       document.getElementById("pacViewPlace"),
       {
         fields: ["geometry", "name"],
       }
     );
     autocomplete.addListener("place_changed", () => {
       this.viewer.entities.removeAll();
       const place = autocomplete.getPlace();
       if (!place.geometry || !place.geometry.viewport) {
         window.alert("No viewport for input: " + place.name);
         return;
       }
       this.zoomToViewport(place.geometry.viewport);  // changed `zoomToViewport` to `this.zoomToViewport`
     });
    }
  }
};
</script>

<style scoped>
.cesium-viewer-toolbar {
  display: none;
}
#cesiumContainer {
  height: 100vh;
  width: 100vw;
}
</style>
